// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ntFn","index":"styles_index__u9zxg"};